import { render, staticRenderFns } from "./EventKind.vue?vue&type=template&id=1eac2563"
import script from "./EventKind.vue?vue&type=script&lang=js"
export * from "./EventKind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports